const checkExclusiveOr = (parts, flatConfigurationParts) => {
    const result = [];

    parts.forEach((part) => {
        // Vereinige die Arrays exclusive_or und exclusive_or2 falls vorhanden, sonst leere Arrays
        const group1 = part.exclusive_or || [];
        const group2 = part.exclusive_or2 || [];

        const enabledExclusiveOrs = group1.filter((exclusiveOr) => {
            const found = flatConfigurationParts.some(
                (selectedItem) => selectedItem.uid === exclusiveOr
            );
            return found;
        });

        const enabledExclusiveOrs2 = group2.filter((exclusiveOr2) => {
            const found2 = flatConfigurationParts.some(
                (selectedItem) => selectedItem.uid === exclusiveOr2
            );
            return found2;
        });

        // Füge part.uid zu result hinzu, wenn exclusiveOrs nicht leer ist
        // und keine entsprechenden Teile aktiv sind
        if ((group1.length !== 0 && enabledExclusiveOrs.length === 0) ||
            (group2.length !== 0 && enabledExclusiveOrs2.length === 0)) {
            result.push(part.uid);
        }
    });

    return result;
};

export default checkExclusiveOr;
